module.exports = __webpack_public_path__ + "static/media/check_thick.45f05943.svg";